<script lang="ts">
	import { type Achievement } from '../../../../domain/Achievement';
	import AchievementSponsoredTag from '$components/home/achievement/elements/old/AchievementSponsoredTag.svelte';

	export let achievement: Achievement;
	export let display: 'row' | 'grid';

</script>

<div
	class:grid-card-container={display==="grid"}
	class:row-card-container={display==="row"}
	data-testid="achievement-base-card"
>
	<slot></slot>
	{#if achievement.content.sponsor}
		<div
			data-testid="sponsor-tag"
			class="oc-pt-50"
			class:grid-sponsor-tag={display==="grid"}
			class:row-sponsor-tag={display==="row"}
		>
			<AchievementSponsoredTag achievementId={achievement.achievementId} />
		</div>
	{/if}
</div>

<style lang="scss">
  .row-card-container {
    position: relative;
    margin-bottom: 30px;
		display: flex;
  }

  .grid-card-container {
    display: flex;
    flex-direction: column;
  }

  .grid-sponsor-tag {
    align-self: end;
  }

  .row-sponsor-tag {
    position: absolute;
    right: 0;
    bottom: -30px;
  }
</style>
